import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { useEffect } from "react";
import { callbackify } from "util";
import GoogleMap from "../components/contact/GoogleMap";
import Loading from "../components/_main/Loading";
import "./styles/Contact.css"

function Contact() {
    const call = (tel: string) => {
        var call_app = window.open("tel:" + tel, "_self");
        call_app!.close();
    }

    useEffect(() => {
        window.document.title = "Contacto"
    }, [])

    return (
        <div className="Contact-area">
            <div>
                <Wrapper apiKey={"AIzaSyBdlxShNQWpYGFKf0moV-aEBqMN5DyRVPs"} render={render}>
                    <GoogleMap style={{ "height": "640px", "width": "calc(100% - 30px)", "marginLeft": "15px", "marginTop": "15px" }} />
                </Wrapper>
            </div>
            <div className="hospital-info-container">
                <br></br><br></br><br></br>
                <h2 className="direc-title">Dirección</h2>
                <div className="info-card-hospital">
                    
                    <div className="hospital-info">
                        <div className="letter-hospital">A</div>
                        <div className="hospital-text">
                            <p className="hospital-name">Instituto Medicina Fetal México</p>
                            <p className="normal-text-hospital-info">
                                San Gabriel #333<br />
                                Col. Chapalita<br />
                                CP 45040<br />
                                Guadalajara, Jal.<br />
                                México
                            </p>
                            <p className="normal-text-hospital-info">Horario de atención telefónica 9:00am - 8:00pm </p>
                            <br></br>
                            <div style={{display:"flex", gap:"50px" }}>
                                <p onClick={() => call("+523328152200")} className="normal-text-hospital-info hospital-phone" style={{ "fontWeight": "bold" }}>
                                <i className="fa fa-phone" aria-hidden="true" />
                                Citas. (33) 281 522 00
                            </p>
                            <p onClick={() => window.open("https://wa.me/523328152200")} className="normal-text-hospital-info hospital-phone" style={{ "fontWeight": "bold" }}><i className="fa fa-whatsapp" aria-hidden="true" />(33) 281 522 00 </p>
                            </div>
                            
                            <p onClick={() => call("+523320377666")} className="normal-text-hospital-info hospital-phone" style={{ "fontWeight": "bold" }}>
                                <i className="fa fa-phone" aria-hidden="true" />
                                Cirugía Fetal. (+52) 33 2037 7666
                            </p>
                            
                            <p onClick={() => call("+523310824629")} className="normal-text-hospital-info hospital-phone" style={{ "fontWeight": "bold" }}>
                                <i className="fa fa-phone" aria-hidden="true" />
                                Programas de educación Médica. (+52) 3310824629
                            </p>
                            
                            <div className="" style={{display:"flex", flexDirection:"column", margin:"10px auto"}}>
                                <a href="mailto:contactogdl@medicinafetalmexico.com">
                                    <div className="contact-btn" >
                                        <span style={{fontSize:"12px"}}>contactogdl@medicinafetalmexico.com</span>
                                    </div>
                                </a>
                                <a href="mailto:educacion@medicinafetalmexico.com">
                                    <div className="contact-btn" >
                                        <span style={{fontSize:"12px"}}>educacion@medicinafetalmexico.com</span>
                                    </div>
                                </a>
                            </div>
                            
                        </div>
                    </div>
                </div>
                {/*<h2 className="direc-title">Envíanos un mensaje</h2>
                <p style={{ "textAlign": "center", "fontSize": "15px", "animation": "3s anim-lineUp ease-out" }}>Un especialista se pondrá en contacto contigo.</p>
                <br></br>
                <div className="form-content">
                    <form className="form-contact">
                        <input className="contact-input" type="text" placeholder="Nombre (requerido)" name="nombre"></input>
                        <input className="contact-input" type="text" placeholder="Correo electrónico (requerido)" name="nombre"></input>
                        <input className="contact-input" type="text" placeholder="Asunto" name="nombre"></input>
                        <input className="contact-input" type="text" placeholder="Mensaje" name="nombre"></input>
                        <div className="contact-btn">ENVIAR</div>
                    </form>
                </div>*/}
            </div>
        </div>
    );
}

const render = (status: Status) => {
    return <Loading />;
};

export default Contact;
